import e from"styled-components";import{theme as i}from"../../../theme.js";const t=e.div`
  padding: 0 ${i.spacing*4}px ${i.spacing*4}px;
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  max-height: 600px;
  overflow-y: auto;
  a {
    text-decoration: none;
    color: inherit;
  }
  @media screen and (max-width: ${i.breakpoints.md}) {
    padding: ${i.spacing*4}px;
    max-height: unset;
  }
`,a=e.div`
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: ${i.spacing*4}px;
  align-items: center;
  .avatar-container {
    position: relative;
    > svg {
      position: absolute;
      bottom: -2px;
      right: -2px;
      width: 16px;
      height: 16px;
    }
  }
  .displayName {
    color: ${i.colors.gray[900]};
    font-weight: 700;
  }
`;export{t as Container,a as UserWrapper};
